module.exports = __webpack_public_path__ + "static/img/header-bg.d8f1f32.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fundamentals/header-bg.png
// module id = +rFs
// module chunks = 0